module.exports = __webpack_public_path__ + "img/SME500_2021_Trademark_Authorised.16220228.png";